module.exports = __webpack_public_path__ + "img/diamondMagic.e88e73e.webp";